import { render, staticRenderFns } from "./RegionFilters.vue?vue&type=template&id=725e66a0&"
import script from "./RegionFilters.vue?vue&type=script&lang=js&"
export * from "./RegionFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports